import React from 'react';
import { Tooltip } from '@material-tailwind/react'

export default function({ thumbnail, item, unitOfMeasurements, manufacturer, brand, packSize, supplier }) {
    return (
        <div
            className="relative flex bg-clip-border rounded-xl bg-white text-gray-700 shadow-md w-full flex-row">
            <div
                className="flex items-center justify-center w-2/5 m-0 overflow-hidden text-gray-700 bg-white rounded-r-none bg-clip-border rounded-xl shrink-0">
                <img src={thumbnail} alt="card-image"
                     className="object-contain" style={{ width: '100px', height: '125px' }} />
            </div>

            <div className="p-2">
                <h2 className="my-2 text-lg font-semibold text-gray-900 dark:text-white">
                    <Tooltip content="Item">
                        {item}
                    </Tooltip>
                </h2>

                <ul className="max-w-md space-y-2 text-gray-700 list-disc list-inside dark:text-gray-400">
                    <li>
                        <Tooltip content="Unit of measurements">
                            {unitOfMeasurements}
                        </Tooltip>
                    </li>
                    <li>
                        <Tooltip content="Manufacturer">
                            {manufacturer}
                        </Tooltip>
                    </li>
                    <li>
                        <Tooltip content="Brand">
                            {brand}
                        </Tooltip>
                    </li>
                    <li>
                        <Tooltip content="Pack Size">
                            {packSize}
                        </Tooltip>
                    </li>
                    <li>
                        <Tooltip content="Supplier">
                            {supplier}
                        </Tooltip>
                    </li>
                </ul>
            </div>
        </div>
    )
}
